var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron"},[_c('image-with-descriptions',{staticClass:"mb-8 mt-0",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.oImage1.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.oImage1.alt,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    },
                    {
                        text: _vm.currentPage.images.oImage1.text,
                        position: 'bottom-left', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}})],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'from-sushi',
                    to: 'to-golden_sand',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleTitle.text)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleDescription.text)}}),_c('div',{staticClass:"container-components mt-8"},[_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphOne_Title.text
                            )}})]),_c('p',{staticClass:"xl:text-lg text-nandor",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphOne_Content.text
                        )}})],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{staticClass:"inline-flex",attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTwo_Title.text
                            )}})]),_c('p',{staticClass:"xl:text-lg text-nandor",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphTwo_Content.text
                        )}})],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphThree_Title
                                    .text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphThree_Content
                                    .text
                            )}})])],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFour_Title
                                    .text
                            )}})]),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFour_Content
                                    .text
                            )}})]),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage2.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage2
                                            .alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: _vm.currentPage.images.oImage2
                                            .text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFive_Content
                                    .text
                            )}})])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-sushi',
                            to: 'to-golden_sand',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphSix_Title.text
                            )}}),_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}})],1),_c('paragraph',{attrs:{"options":{
                            color: 'text-nandor',
                        }}},[_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphSix_Content
                                    .text
                            )}})]),_c('div',[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                    icon: 'diaporama',
                                    collection: _vm.getRichmediaByCollection(
                                        _vm.currentPage,
                                        'Faire simple avec Ap’Hy'
                                    ),
                                }}})],1),_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage3.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage3
                                            .alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: _vm.currentPage.images.oImage3
                                            .text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1)])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }